import * as Yup from 'yup';
import i18next from '../i18n';

export const emailLoginValidationSchema = Yup.object({
  email: Yup.string().required(
    i18next.t('validationSchema.general.emailOrUsernameRequired'),
  ),
});
